import { render, staticRenderFns } from "./ConversationMessagePin.vue?vue&type=template&id=4a48d53c&scoped=true&"
import script from "./ConversationMessagePin.vue?vue&type=script&lang=js&"
export * from "./ConversationMessagePin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a48d53c",
  null
  
)

export default component.exports